export default __webpack_public_path__ + "/dist/images/4588423.png";